import React, { useState } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { customStyles, spaceBetween } from '../../../styles';
import { PreviewStackContainer } from './PreviewStackContainer';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import { animations } from '../../../utils/animations';
import { setPaymentMethod } from '../../../slices/orderSlice';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
export const Payment = () => {
   const dispatch = useDispatch()
   const style = {
      color: customStyles.colors.main
   }
   const [payment, setPayment] = useState(true)
   const handlePayment = () => {
      setPayment(!payment)
      !payment ? dispatch(setPaymentMethod('Efectivo')) : dispatch(setPaymentMethod('Terminal'))
      
   }

   useEffect(() => {
      payment 
      ? dispatch(setPaymentMethod('Efectivo'))
      : dispatch(setPaymentMethod('Terminal'))
      
   }, [])
  return (
   <PreviewStackContainer text="¿Como pagarás tu servicio?">
      <Stack width="100%" spacing={2}>
         <Box sx={ {...spaceBetween, width:  "100%"} }>
            <Stack direction="row" alignItems="center" spacing={2}>
               {
                  payment
                  ?  <PaymentsOutlinedIcon sx={style} className={animations.ruber}/>
                  :  <CreditCardIcon sx={style} className={animations.ruber}/>
               }
               <Typography component="p" variant="body2">{ payment ? 'Efectivo' : 'Terminal'}</Typography> 
            </Stack>
            <ModeEditOutlineOutlinedIcon sx={{ color: customStyles.colors.textColor, cursor: 'pointer' }} onClick={handlePayment}/>
         </Box>
      </Stack>
   </PreviewStackContainer>
  )
}
